import React, { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { change, Field, formValueSelector, isDirty, reset } from "redux-form"
import { connect } from "react-redux"
import { FORM_NAMES } from "constants/index"
import PhonePreview from "./phonePreview"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import BottomNavigation from "components/BottomNavigation"
import { CustomImageField } from "components/RenderInput"

const BackgroundTab = ({
  bgImage,
  handleSave,
  change,
  handleBack,
  handleNext,
  isDirty,
  resetForm,
  tabIsActive,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>Change background</h4>
            </CardHeader>
            <CardBody>
              <Row className="my-3">
                <Col xs={7}>
                  <Row>
                    <Col xs={"auto"} className="mt-2">
                      <label>Change Background:</label>
                    </Col>
                    <Col xs={"auto"}>
                      <Field
                        name="bgImage"
                        component={CustomImageField}
                        removeButtonDisabled={true}
                        onChange={() => {
                          change("background.deleteBackground", 1)
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <span>
                      <b>NOTE:</b> For best results, size image to: 1440px x
                      2960px
                    </span>
                  </Row>
                  <Row>
                    <span>
                      For best performance results, upload a GIF or 5 MB .mov
                    </span>
                  </Row>
                </Col>
                <Col xs={5} className="d-flex justify-content-end">
                  {bgImage && bgImage?.editedImage && (
                    <img
                      src={bgImage?.editedImage ? bgImage?.editedImage : ""}
                      alt="bgImage"
                      className="rounded avatar-xl"
                      style={{ blockSize: "auto" }}
                    />
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation
            handleSave={handleSave}
            handleBack={handleBack}
            handleNext={handleNext}
          />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.LANDING_SCREEN)

const mapStateToProps = state => ({
  bgImage: selector(state, "background.bgImage"),
  isDirty: isDirty(FORM_NAMES.LANDING_SCREEN)(state, ...["background"]),
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.LANDING_SCREEN, `${field}`, value)),
  resetForm: () => dispatch(reset(FORM_NAMES.LANDING_SCREEN)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundTab)
